<template>
    <div
        style="width: 100%;
            height: 600px;
            background-color: white;
            z-index: 999;
            position: fixed;
            top: 0px;
            overflow-y: auto;"
        class="preview-window">
        <v-container py-5 style="max-width: 800px;">
            <v-layout row wrap style="padding-top: 120px">
                <a style="text-decoration: underline" @click="this.return">Назад к оформлению</a>
            </v-layout>

            <v-layout row wrap class="preview-title" v-show="b2b">
                <h1>Предварительный просмотр</h1>
                <p >Пожалуйста, проверьте правильность введенных данных:</p>
            </v-layout>

            <v-layout row wrap pt-3 class="preview-title" v-show="!b2b">
                <h2>Эти данные будут в полисе. <br><u>Внимательно проверьте их!</u></h2>
            </v-layout>

            <v-container px-0 py-5>
                <v-layout pt-4 row wrap>
                    <v-flex xs12 sm6 md4>
                        <v-btn class="preview-button block"
                               @click="this.submit"
                               :loading="this.loading"
                        >Всё верно!
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-btn class="preview-button block"
                               style="color: black !important;
                                      background-color: white !important;
                                      border: solid 1px #c7c7c7;"
                               @click="this.return"
                        >Редактировать
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>
    </div>
</template>

<script>
export default {
    name: "MortgagePreviewForm",
    props: ['preparedFormData', 'return', 'submit', 'b2b', 'loading'],

    data: function () {
        return this.preparedFormData;
    },
}
</script>

<style scoped>

.preview-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 19px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    width: 90%;
    background-color: #00ba57 !important;;
    text-align: center;
    padding: 0 30px !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.preview-title h1{
    padding: 27px 0;
}
.preview-title p{
    font-size: 20px;
    padding: 5px 0
}

@media screen and (max-width: 650px){
    .preview-title h1{
        font-size: 32px;
    }
    .preview-title p{
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgagePreviewForm.vue